import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../context/AuthContext';
import CountryCodePicker from '../CountryCodePicker'; // Özel ülke kodu seçici bileşenimiz
import TimezoneSwitcher from '../TimezoneSwitcher';
import { timezones } from '../../data/timezones';
const API_URL = process.env.REACT_APP_API_URL;
// Bu bileşen, hem Müşteri hem de Çevirmen tarafından kullanılır.
// Giriş yapan kullanıcının rolüne göre farklı alanlar gösterir.
const AccountDetails = () => {
  const { t } = useTranslation();
  const { user, token } = useAuth(); // AuthContext'ten global kullanıcı bilgilerini al
  
  const [formData, setFormData] = useState({}); // Form verilerini tutan state
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
const [isTimezoneOpen, setIsTimezoneOpen] = useState(false);
  // Hangi API'ye istek atılacağını kullanıcının rolüne göre dinamik olarak belirle
  const API_URL_GET = user?.role === 'translator' 
    ? `${API_URL}/api/dashboard/profile` 
    : `${API_URL}/api/auth/me`;

  const API_URL_PUT = user?.role === 'translator'
    ? `${API_URL}/api/dashboard/profile`
    : `${API_URL}/api/auth/profile`;

  // Bileşen yüklendiğinde kullanıcının mevcut profil bilgilerini backend'den çek
  useEffect(() => {
    const fetchProfile = async () => {
      if (!token) {
        setLoading(false);
        return;
      }
      try {
        setLoading(true);
        setError('');
        const response = await fetch(API_URL_GET, {
          headers: { 'Authorization': `Bearer ${token}` }
        });
        if (!response.ok) throw new Error(t('error_fetch_profile'));
        const data = await response.json();
        setFormData(data); // Gelen veriyi doğrudan form state'ine ata
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchProfile();
  }, [token, t, API_URL_GET]);

  // Formdaki herhangi bir input değiştiğinde state'i güncelle
  const handleChange = (e) => {
    setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  // Ülke kodu seçicisi değiştiğinde state'i güncelle
  const handleCountryCodeChange = (code) => {
    setFormData(prev => ({ ...prev, phone_country_code: code }));
  };
const handleTimezoneChange = (tz) => setFormData(p => ({ ...p, timezone: tz }));
  // Form gönderildiğinde
  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');
    setError('');
    
    let submissionData = {};

    // Kullanıcının rolüne göre backend'e gönderilecek veriyi hazırla
    if (user.role === 'translator') {
      submissionData = {
        firstName: formData.first_name,
        lastName: formData.last_name,
        countryCode: formData.phone_country_code,
        phone: formData.phone_number,
        mainLanguage: formData.main_language,
        country: formData.country,
        city: formData.city,
		timezone: formData.timezone,
      };
    } else if (user.role === 'customer') {
      submissionData = {
        firstName: formData.first_name,
        lastName: formData.last_name,
        countryCode: formData.phone_country_code,
        phone: formData.phone_number,
        timezone: formData.timezone
      };
    } else {
        setError("Invalid user role.");
        return;
    }

    try {
      const response = await fetch(API_URL_PUT, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
        body: JSON.stringify(submissionData)
      });
      if (!response.ok) {
        const data = await response.json();
        throw new Error(t(data.messageKey) || t('error_profile_update'));
      }
      setMessage(t('success_profile_updated'));
    } catch (err) {
      setError(err.message);
    }
  };
  
 if (loading || !user) return <div><i className="fas fa-spinner fa-spin"></i> {t('loading_profile')}</div>;
  if (error) return <div className="error">{error}</div>;

  return (
    <>
      <div className="profile-form-container">
        <h2>{t('account_details')}</h2>
        <form onSubmit={handleSubmit}>
          {/* Ortak Alanlar */}
          <div className="form-row-auth">
            <div className="form-group-auth floating-label half-width"><input id="first_name" name="first_name" type="text" value={formData.first_name || ''} onChange={handleChange} required placeholder=" " /><label htmlFor="first_name">{t('first_name')}</label></div>
            <div className="form-group-auth floating-label half-width"><input id="last_name" name="last_name" type="text" value={formData.last_name || ''} onChange={handleChange} required placeholder=" " /><label htmlFor="last_name">{t('last_name')}</label></div>
          </div>
          <div className="form-row-auth">
            <div className="form-group-auth phone-code">
             
              <CountryCodePicker selectedCode={formData.phone_country_code || '+90'} onCodeChange={handleCountryCodeChange} />
            </div>
            <div className="form-group-auth floating-label phone-number">
              <input id="phone_number" name="phone_number" type="tel" value={formData.phone_number || ''} onChange={handleChange} placeholder=" " /><label htmlFor="phone_number">{t('phone')}</label>
            </div>
          </div>
          <div className="form-group-auth floating-label">
            <input id="email" name="email" type="email" value={formData.email || ''} disabled placeholder=" " /><label htmlFor="email">{t('email_address')}</label>
          </div>
          
          <div className="form-group-auth">
            <label className="static-label">{t('local_timezone')}</label>
            <div className="timezone-display-input" onClick={() => setIsTimezoneOpen(true)}>
                {formData.timezone || t('select_timezone')}
            </div>
          </div>

          {/* Sadece Çevirmene Özel Alanlar */}
          {user.role === 'translator' && (
            <>
              <div className="form-group-auth floating-label">
                    <input id="main_language" name="main_language" type="text" value={formData.main_language || ''} 
                       disabled // Her zaman pasif
                       placeholder=" " />
                <label htmlFor="main_language">{t('main_language')}</label>
              </div>
              <div className="form-row-auth">
                  <div className="form-group-auth floating-label half-width">
                      <input id="country" name="country" type="text" value={formData.country || ''} onChange={handleChange} placeholder=" " />
                      <label htmlFor="country">{t('country')}</label>
                  </div>
                  <div className="form-group-auth floating-label half-width">
                      <input id="city" name="city" type="text" value={formData.city || ''} onChange={handleChange} placeholder=" " />
                      <label htmlFor="city">{t('city')}</label>
                  </div>
              </div>
            </>
          )}

          {/* Sadece Müşteriye Özel Alanlar */}
          {user.role === 'customer' && (
            <>
              <div className="form-group-auth customer-type">
                  <label className="static-label">{t('customer_type')}</label>
                  <div className="radio-group">
                      <label className="auth-radio"><input type="radio" name="customer_type" value="bireysel" checked={formData.customer_type === 'bireysel'} onChange={handleChange}/><span>{t('individual_customer')}</span></label>
                      <label className="auth-radio"><input type="radio" name="customer_type" value="kurumsal" checked={formData.customer_type === 'kurumsal'} onChange={handleChange}/><span>{t('corporate_customer')}</span></label>
                  </div>
              </div>
              {formData.customer_type === 'kurumsal' && (
                  <div className="form-group-auth floating-label">
                      <input id="company_name" name="company_name" type="text" value={formData.company_name || ''} onChange={handleChange} placeholder=" " />
                      <label htmlFor="company_name">{t('company_name')}</label>
                  </div>
              )}
            </>
          )}

        {message && <p className="auth-success">{message}</p>}
        {error && <p className="auth-error">{error}</p>}
        <button type="submit" className="cta-button">{t('save_changes')}</button>
      </form>
    </div>
  <TimezoneSwitcher 
        isOpen={isTimezoneOpen} 
        onClose={() => setIsTimezoneOpen(false)}
        timezones={timezones}
        selectedTimezone={formData.timezone}
        onTimezoneChange={handleTimezoneChange}
      />
    </>
  );
};
export default AccountDetails;